import { render, staticRenderFns } from "./_route.vue?vue&type=template&id=1a896ff1&"
import script from "./_route.vue?vue&type=script&lang=js&"
export * from "./_route.vue?vue&type=script&lang=js&"
import style0 from "./_route.vue?vue&type=style&index=0&id=1a896ff1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports